var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCvLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 468 500",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.028 16.0301L407.329 80.1504C440.369 89.0036 459.977 122.965 451.124 156.006L374.981 440.175C366.128 473.215 332.166 492.823 299.126 483.97L59.8252 419.849C26.7847 410.996 7.17696 377.035 16.0301 343.994L92.173 59.8251C101.026 26.7846 134.988 7.17692 168.028 16.0301ZM160.013 45.9426C143.493 41.516 126.512 51.3199 122.086 67.8401L45.9427 352.009C41.5161 368.53 51.3199 385.51 67.8402 389.937L307.141 454.057C323.661 458.484 340.642 448.68 345.068 432.16L421.211 147.991C425.638 131.47 415.834 114.49 399.314 110.063L160.013 45.9426Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.932 124.732C157.145 116.472 165.636 111.57 173.896 113.784L353.371 161.874C361.631 164.087 366.533 172.578 364.32 180.838C362.107 189.098 353.616 194 345.356 191.786L165.881 143.696C157.621 141.483 152.719 132.992 154.932 124.732Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.894 199.514C137.108 191.254 145.598 186.352 153.858 188.565L333.334 236.655C341.594 238.869 346.496 247.359 344.282 255.619C342.069 263.879 333.579 268.781 325.319 266.568L145.843 218.478C137.583 216.264 132.681 207.774 134.894 199.514Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.857 274.295C117.07 266.035 125.561 261.133 133.821 263.346L238.515 291.399C246.775 293.612 251.677 302.103 249.463 310.363C247.25 318.623 238.76 323.525 230.5 321.312L125.806 293.259C117.546 291.046 112.644 282.555 114.857 274.295Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvLogo);
export default __webpack_public_path__ + "static/media/cv-logo.c6a5e473.svg";
export { ForwardRef as ReactComponent };